import { render, staticRenderFns } from "./Who5Modal.vue?vue&type=template&id=2f18a662"
import script from "./Who5Modal.vue?vue&type=script&lang=js"
export * from "./Who5Modal.vue?vue&type=script&lang=js"
import style0 from "./Who5Modal.vue?vue&type=style&index=0&id=2f18a662&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports